// GCCV2PersonalityEngineResult.tsx
import React from "react";
import GCCV2TabDashboard from "./GCCV2TabDashboard";
import { getGCCV2StrictLanguageInstruction } from "../../../utils/GCC/astriaGCCV2Language";

const PROMPT = {
  en: (dob: string) =>
    `Give me my GCC Personality Engine reading — my core traits, interaction style, growth area, and personal strengths.\nDate of Birth: ${dob}\n${getGCCV2StrictLanguageInstruction("en")}`,
  ar: (dob: string) =>
    `أعطني قراءة "محرك الشخصية" الخاصة بي — سماتي الأساسية، وأسلوب تفاعلي، ومجال نموي، ونقاط قوتي الشخصية.\nتاريخ الميلاد: ${dob}\n${getGCCV2StrictLanguageInstruction("ar")}`,
};

const GCCV2PersonalityEngineResult: React.FC = () => (
  <GCCV2TabDashboard
    tab="personality"
    tabKey="personality"
    subCategoryMatch="personality"
    buildPrompt={(dob, language) => PROMPT[language](dob)}
    title={{ en: "Your Personality", ar: "شخصيتك" }}
    subtitle={{
      en: "Core traits, interaction style, growth area, and personal strengths.",
      ar: "سماتك الأساسية، وأسلوب تفاعلك، ومجال نموك، ونقاط قوتك الشخصية.",
    }}
  />
);

export default GCCV2PersonalityEngineResult;
